import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, TitleStrategy, withComponentInputBinding } from '@angular/router';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { baseUrlInterceptor, impersonationInterceptor } from './core/interceptors';
import { AppTitleStrategy } from './core/routing/app-title-strategy';
import { angusTheme } from './layout/themes';


export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideHttpClient(withInterceptors([baseUrlInterceptor, impersonationInterceptor])),
        provideRouter(routes, withComponentInputBinding()),
        { provide: TitleStrategy, useClass: AppTitleStrategy },
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: angusTheme, options: { darkModeSelector: '.app-dark' } } }),
        MessageService
    ]
};
